import React, { useState, useEffect } from "react";
import {
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  Col,
  Button,
  Label,
} from "reactstrap";
import {
  CREATE_TRIVVY_MODAL_IMAGES,
  CUSTOM_QUESTION_INPUT_TYPES,
  MAX_OPTIONS_ARRAY,
  MIN_OPTIONS_ARRAY,
} from "../../data";
import Select from "react-select";
import QuizTextEditor from "../../../../components/QuizTextEditor/QuizTextEditor";
import { BiXCircle } from "react-icons/bi";
import { isMobile } from "../../../../utils/deviceInfo";
import RangeInput from "../../../../components/RangeInput/RangeInput";
import axios from "../../../../axios";
import * as url from "../../../../utils/url";
import ReactTooltip from "react-tooltip"

export default function LibQuestionFormFields({questionData,setQuestionData,}) {
    const [hoveredOption, setHoveredOption] = useState(null);
    const getOptionName = (index) => {
        const str = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    
        return str[index];
      };
    const changeLinearNumericConfigs = (val) => {
        setQuestionData({
          ...questionData,
          linearNumericConfigs: val,
        });
      };
    
      const editOptionsText = (index, value) => {
        let optionsArr = [...questionData.options];
        optionsArr[index] = value;
        setQuestionData({
          ...questionData,
          options: optionsArr,
        });
      };
    
      const addOptionsText = (text) => {
        let optionsArr = [...questionData.options];
        optionsArr.push(text);
        setQuestionData({
          ...questionData,
          options: optionsArr,
        });
      };
    
      const removeOption = (index) => {
        let optionsArr = [...questionData.options];
        optionsArr.splice(index, 1);
    
        setQuestionData({
          ...questionData,
          options: optionsArr,
        });
      };
  return (
    <div className={isMobile?"px-2":"px-3"}><div className="mt-3" style={{ marginBottom: "70px",marginLeft:"-20px" }}>
    <QuizTextEditor
      value={questionData.text}
      onChange={(value) =>
        setQuestionData({ ...questionData, text: value })
      }
      styles={{
        fontSize: "19px",
        maxWidth: "100%",
        width: "100%",
      }}
      placeholder="Enter Question Here ...."
      questionId={null}
      toolbarBottom
      blockId="xx"
    />
  </div>

  {(questionData.questionType === "MCQ" || questionData.questionType !== "TEXT" || questionData.questionType !== "LINEAR_NUMERIC" )&& (
    <div className="my-3">
      <Row className={!isMobile && ""}>
        {questionData.options.map((x, idx) => {
          const isCorrect = x == questionData.correctOption;
          const hovered = idx == hoveredOption;
          return (
            <Col
              sm={isMobile ? 12 : 4}
              className="px-2 py-1 d-flex"
              key={idx}
            >
              <div
                className="trivia-survey-edit-questions-ui_option_item"
                style={{
                  flexGrow: 1,
                  backgroundColor: isCorrect ? "green" : "white",
                  color: isCorrect ? "white" : "black",
                  boxShadow: ` 0px 0px 0px 1px grey`,
                }}
                onMouseEnter={() => setHoveredOption(idx)}
                onMouseLeave={() => setHoveredOption(null)}
              >
                <span className="option_name_wrapper cursor-pointer" onClick={()=>{
                  setQuestionData({
                    ...questionData,
                    correctOption:x
                  })
                }} data-tip={"Click to set as correct answer"}>
                  
                  {getOptionName(idx)}
                </span>
                <ReactTooltip />

                {/* {question.is_ai_generated ? (
                <span className="edit_survey_question_wrapper_noborder small_font_edit">
                  {x.text}
                </span>
              ) : ( */}
                <QuizTextEditor
                  value={x}
                  onChange={(e) => {
                    editOptionsText(idx, e);
                  }}
                  styles={{
                    fontSize: "13px",
                    maxHeight: "200px",
                    width: "100%",
                  }}
                  placeholder="Enter Option ...."
                  hideToolbar
                  questionId={x}
                />
                {/* )} */}

                {hoveredOption === idx && (
                  <BiXCircle
                    className="trivia_questions_ui_remove_option_cross"
                    color="white"
                    size={24}
                    onClick={() => removeOption(idx)}
                  />
                )}
              </div>
            </Col>
          );
        })}

        {
          questionData.questionType =="MCQ" && 
          <Col sm={isMobile ? 12 : 4} className="m_t_auto">
            <span
              style={{
                textDecoration: "underline",
                cursor: "pointer",
                marginTop: "auto",
                marginBottom: "12px",
              }}
              onClick={() =>
                addOptionsText(
                  `Choice ${questionData.options.length + 1}`
                )
              }
              className="mt-4"
            >
              {" "}
              Add choice{" "}
            </span>
          </Col>
        }

      </Row>
    </div>
  )}

  {questionData.questionType === "LINEAR_NUMERIC" && (
    <div className="my-3">
      <div className="question_edit_min_max_ui">
        <RangeInput
          className="mt-2"
          min={questionData.linearNumericConfigs.min}
          max={questionData.linearNumericConfigs.max}
          value={0}
          onChange={(v) => {}}
        />

        <div className="mt-4">
          <b>Select Min-Max range:</b>
          <div className="d-flex align-items-center">
            <div>
              <Select
                options={MIN_OPTIONS_ARRAY.filter(
                  (x) =>
                    x.value < questionData.linearNumericConfigs.max
                )}
                className="w-70"
                value={questionData.linearNumericConfigs.min || 1}
                placeholder="Set Minimum"
                onChange={(e) =>
                  changeLinearNumericConfigs({
                    ...questionData.linearNumericConfigs,
                    min: e.value,
                  })
                }
              />
            </div>
            <div className="mx-2">to</div>
            <div>
              <Select
                options={MAX_OPTIONS_ARRAY}
                className="ml-1 w-70"
                value={questionData.linearNumericConfigs.max}
                placeholder="Set Maximum"
                onChange={(e) =>
                  changeLinearNumericConfigs({
                    ...questionData.linearNumericConfigs,
                    max: e.value,
                  })
                }
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )}</div>
  )
}
